import { useEffect } from 'react';

import styles from './AgedDebtorReport.module.css';
import { useGetDocuments } from '../../../../api/lendingApi/lendingApiQueries';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useFileUploadReducer } from '../../../../hooks/useFileUploadReducer';
import DragDropUpload from '../components/DragDropUpload/DragDropUpload';
import FileStatusSections from '../components/FileStatusSections/FileStatusSections';

const DOCUMENT_TYPE = 'aged debtor report';
const listOfInstructions = [
  <>
    This should be a list of invoices you have issued but are yet to be paid,
    and ideally grouped by the number of days outstanding e.g. (30, 60, 90+
    days).{' '}
    <a
      href="https://gocardless.com/guides/posts/aged-debtors-report/"
      target="_blank"
      rel="noreferrer"
    >
      Learn more
    </a>
    .
  </>,
];
const AgedDebtorReport = () => {
  const stateKey = useContextStateKey();
  const { documents } = useGetDocuments(stateKey);

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  useEffect(() => {
    if (documents) {
      const bankStatementDocuments = documents.data.filter(
        (document) => document.attributes.document_type === DOCUMENT_TYPE,
      );
      setAllFiles(bankStatementDocuments);
    }
  }, [documents]);

  return (
    <div className={styles.container}>
      <DragDropUpload
        documentType={DOCUMENT_TYPE}
        listOfInstructions={listOfInstructions}
        setFileLoading={setFileLoading}
        setFileSuccess={setFileSuccess}
        setFileError={setFileError}
        setFileReject={setFileReject}
      />

      <FileStatusSections files={uploadedFiles} removeFile={removeFile} />
    </div>
  );
};

export default AgedDebtorReport;
